import { CollectionFolder } from 'editor/src/store/collections/types';
import { MediaImage, SlotFileSet, SlotFrame } from 'editor/src/store/design/types';
import { buildAdvPersoPluginsUpdate, CollectionDisplayOption } from 'editor/src/store/plugins/utils/advPersoUtils';

import getCenteredImagePosition from 'editor/src/util/2d/getCenteredImagePosition';

import getSlotFolderAssets from './getSlotFolderAssets';
import { slotLinkGroupId } from './slotLayoutIds';

interface Options {
  layoutId: string;
  frame: SlotFrame;
  fileSet: SlotFileSet;
  folder: CollectionFolder | undefined;
  uuid: number;
  name: string;
  /** Position of the product's current pick in its linked layers, so the new layer shows it too. */
  assetIndex?: number;
}

/**
 * The picture layer a frame starts with: a dropdown collection layer filling the frame, showing
 * the format's folder and linked with the same product's layers in the other frames.
 */
function buildSlotPictureElement({
  layoutId,
  frame,
  fileSet,
  folder,
  uuid,
  name,
  assetIndex = 0,
}: Options): MediaImage | undefined {
  const folderRef = fileSet.folders[frame.columns];
  if (!folderRef) {
    return undefined;
  }
  const collectionInfo = {
    folderId: folderRef.folderId,
    displayOption: CollectionDisplayOption.Dropdown,
    assetIds: folderRef.assetIds?.length ? folderRef.assetIds : undefined,
    linkGroupId: slotLinkGroupId(layoutId, fileSet.id, frame.product),
  };
  const assets = getSlotFolderAssets(folder, folderRef);
  const asset = assets[assetIndex] ?? assets[0];
  if (!asset) {
    return undefined;
  }

  const element: MediaImage = {
    type: 'image',
    group: '',
    name,
    uuid,
    x: frame.x,
    y: frame.y,
    width: frame.width,
    height: frame.height,
    r: 0,
    px: 0,
    py: 0,
    pw: frame.width,
    ph: frame.height,
    pr: 0,
    imageId: asset.id,
    url: asset.url,
    slotFrame: { layoutId, frameId: frame.id, fileSetId: fileSet.id },
  };
  if (asset.width && asset.height) {
    Object.assign(element, getCenteredImagePosition(element, asset));
  }
  element.plugins = buildAdvPersoPluginsUpdate(element, collectionInfo);
  return element;
}

export default buildSlotPictureElement;
